import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMenuContext } from '../../context';
import BMTriggerButton from './BMTriggerButton';
import IoTMTriggerButton from './IoTMTriggerButton';

type Props = {
  onBMOpen?: () => void;
  onIoTOpen?: () => void;
  onBMClose?: () => void;
  onIoTClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
};

export default function TriggerButtons({
  onBMOpen,
  onBMClose,
  onIoTClose,
  onIoTOpen,
  setMenuIsOpen,
  menuIsOpen,
}: Props) {
  const { open } = useMenuContext();
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  useEffect(() => {
    if (open) {
      setHasBeenOpened(true);
    }
  }, [open]);

  return (
    <>
      <Stack spacing={6}>
        {onBMOpen && (
          <BMTriggerButton
            onOpen={onBMOpen}
            onClose={onBMClose}
            setMenuIsOpen={setMenuIsOpen}
            hasBeenOpened={hasBeenOpened}
            menuIsOpen={menuIsOpen}
          />
        )}
        {onIoTOpen && (
          <IoTMTriggerButton
            onOpen={onIoTOpen}
            onClose={onIoTClose}
            setMenuIsOpen={setMenuIsOpen}
            hasBeenOpened={hasBeenOpened}
            menuIsOpen={menuIsOpen}
          />
        )}
      </Stack>
    </>
  );
}
